import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Setup mode messages
  setupTitle: {
    id: 'App.ManageHUDVouchers.SetupVoucherModal.Title',
    defaultMessage: 'Begin Voucher Management',
  },
  readyQuestion: {
    id: 'App.ManageHUDVouchers.SetupVoucherModal.ReadyQuestion',
    defaultMessage:
      "You're about to begin managing HUD Vouchers for this property so they can be submitted to TRACS.",
  },
  beginDateQuestion: {
    id: 'App.ManageHUDVouchers.SetupVoucherModal.BeginDateQuestion',
    defaultMessage:
      'Select the {voucherMonthYear} you want to start with. ' +
      'This will determine the {firstMonthsVoucher} that will be created for your property.',
  },
  firstMonthsVoucher: {
    id: 'App.ManageHUDVouchers.SetupVoucherModal.FirstMonthsVoucher',
    defaultMessage: "first month's voucher",
  },
  infoMessage: {
    id: 'App.ManageHUDVouchers.SetupVoucherModal.InfoMessage',
    defaultMessage:
      'Once confirmed, voucher automation will begin. A voucher will be created in Draft status ' +
      'each month for the upcoming period, giving you time to review and manage it before submitting it to TRACS.',
  },
  cancel: {
    id: 'App.ManageHUDVouchers.SetupVoucherModal.Cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'App.ManageHUDVouchers.SetupVoucherModal.Confirm',
    defaultMessage: 'Confirm',
  },

  // Manage mode messages
  manageTitle: {
    id: 'App.ManageHUDVouchers.ManageVoucherSetup.Title',
    defaultMessage: 'Manage Voucher Setup',
  },
  updateInstruction: {
    id: 'App.ManageHUDVouchers.ManageVoucherSetup.UpdateInstruction',
    defaultMessage:
      'If you need to change the starting month for the first voucher, select a new {voucherMonthYear} below.',
  },
  updateConfirmation: {
    id: 'App.ManageHUDVouchers.ManageVoucherSetup.UpdateConfirmation',
    defaultMessage:
      'Once confirmed, any Draft vouchers will be automatically updated to align with the new start date.',
  },
  undo: {
    id: 'App.ManageHUDVouchers.ManageVoucherSetup.Undo',
    defaultMessage: 'Undo',
  },
  update: {
    id: 'App.ManageHUDVouchers.ManageVoucherSetup.Update',
    defaultMessage: 'Update',
  },

  // Shared messages
  beginDateLabel: {
    id: 'App.ManageHUDVouchers.VoucherStartDateLabel',
    defaultMessage: 'Voucher Start Date',
  },
  voucherMonthAndYear: {
    id: 'App.ManageHUDVouchers.VoucherMonthAndYear',
    defaultMessage: 'Voucher Month and Year',
  },
  dateError: {
    id: 'App.ManageHUDVouchers.SetupVoucherModal.DateError',
    defaultMessage: 'Must be a month and year in the future.',
  },
  dateErrorPastWindow: {
    id: 'App.ManageHUDVouchers.SetupVoucherModal.DateErrorPastWindow',
    defaultMessage: 'Must be no earlier than {minMonth}.',
  },
  // Per the approved design, `open`, `Anticipated Voucher Date` and `Voucher Start Date` are bold.
  // The trailing "Anticipated Voucher Dates" in the last sentence is deliberately not.
  avdWarning: {
    id: 'App.ManageHUDVouchers.AvdWarning',
    defaultMessage:
      'The <b>Anticipated Voucher Date</b> for all <b>open</b> certifications will change automatically to the ' +
      '<b>Voucher Start Date</b> listed above to begin processing on that Voucher. Anticipated Voucher ' +
      'Dates can always be changed manually within the certification or within the Voucher.',
  },
});

export default messages;
